import { Route, Routes } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RequireAuth from "./Pages/Auth/RequireAuth";
import Checkout from "./Pages/Checkout/Checkout";
import AddBrand from "./Pages/Dashboard/AddBrand";
import AddProduct from "./Pages/Dashboard/AddProduct";
import AllBrands from "./Pages/Dashboard/AllBrands";
import AllProducts from "./Pages/Dashboard/AllProducts";
import Dashboard from "./Pages/Dashboard/Dashboard";
import DashboardHome from "./Pages/Dashboard/DashboardHome";
import Home from "./Pages/Home/Home";
import Login from "./Pages/Login/Login";
import Signup from "./Pages/Login/Signup";
import NotFound from "./Pages/NotFound/NotFound";
import Loading from "./Pages/Shared/Loading";
import Navbar from "./Pages/Shared/Navbar";
import Store from "./Pages/Store/Store";
import BrandProducts from "./Pages/BrandProducts/BrandProducts";
import AllOrders from "./Pages/Dashboard/AllOrders";
import ConfirmOrder from "./Pages/Checkout/ConfirmOrder";
import AllConfirmOrders from "./Pages/Dashboard/AllConfirmOrders";
import AllCompleteOrders from "./Pages/Dashboard/AllCompleteOrders";

function App() {
  return (
    <div className="lg:mx-8">
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/loading" element={<Loading></Loading>}></Route>
        <Route path="/home" element={<Home></Home>}></Route>
        <Route
          path="/brandProducts/:brand_slug"
          element={<BrandProducts></BrandProducts>}
        ></Route>
        <Route
          path="/hello-gas/admin/dashboard"
          element={
            <RequireAuth>
              <Dashboard></Dashboard>
            </RequireAuth>
          }
        >
          <Route index element={<DashboardHome></DashboardHome>}></Route>
          <Route path="allBrands" element={<AllBrands></AllBrands>}></Route>
          <Route path="addBrand" element={<AddBrand></AddBrand>}></Route>
          <Route
            path="allProducts"
            element={<AllProducts></AllProducts>}
          ></Route>

          <Route path="addProduct" element={<AddProduct></AddProduct>}></Route>
          <Route path="allOrders" element={<AllOrders></AllOrders>}></Route>
          <Route
            path="allConfirmOrders"
            element={<AllConfirmOrders></AllConfirmOrders>}
          ></Route>
          <Route
            path="allCompleteOrders"
            element={<AllCompleteOrders></AllCompleteOrders>}
          ></Route>
        </Route>
        <Route path="/store" element={<Store></Store>}></Route>
        <Route
          path="/checkout/:product_id"
          element={<Checkout></Checkout>}
        ></Route>
        <Route
          path="/checkout/confirmOrder/:order_id"
          element={<ConfirmOrder></ConfirmOrder>}
        ></Route>
        <Route path="/hello-gas/admin/login" element={<Login></Login>}></Route>
        <Route
          path="/hello-gas/admin/signup"
          element={<Signup></Signup>}
        ></Route>
        <Route path="*" element={<NotFound></NotFound>}></Route>
      </Routes>
      <ToastContainer />
    </div>
  );
}

export default App;
